import React from 'react';
import { motion } from 'framer-motion';

export default function TermsOfService() {
  return (
    <div className="pt-32 pb-24 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-stone-100"
        >
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4">Terms of Service</h1>
          <p className="text-stone-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-8 text-stone-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Land Quick website, operated by Land Quick ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website or services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">2. Use of Services</h2>
              <p>
                Our website provides a platform for property owners to submit information about their vacant land to receive a potential cash offer. You agree to provide accurate, current, and complete information when submitting your property details.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">3. Property Offers</h2>
              <p>
                Any offer made by Land Quick through this website or subsequent communication is a preliminary estimate based on the information provided and our initial research. No offer is legally binding until a formal Real Estate Purchase Agreement is signed by both parties. We reserve the right to rescind or modify any offer at our sole discretion prior to the execution of a formal contract.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">4. Intellectual Property</h2>
              <p>
                All content, graphics, user interfaces, visual interfaces, photographs, trademarks, logos, and computer code contained on the site is owned, controlled, or licensed by or to Land Quick, and is protected by copyright, patent, and trademark laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">5. Disclaimer of Warranties</h2>
              <p>
                The website and its content are provided on an "as-is" and "as-available" basis. We disclaim all warranties, express or implied, including any warranties of accuracy, non-infringement, merchantability, and fitness for a particular purpose.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">6. Limitation of Liability</h2>
              <p>
                In no event shall Land Quick, its directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages arising from your use of the site or our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">7. Governing Law</h2>
              <p>
                These Terms of Service and your use of the website are governed by and construed in accordance with the laws of the State of Alabama, without regard to its conflict of law principles. Any legal action or proceeding related to your access to, or use of, the website or these Terms shall be instituted only in a state or federal court located in Alabama.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">8. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms of Service at any time. We will notify users of any changes by updating the "Last Updated" date of these Terms. Your continued use of the site following the posting of changes will mean that you accept and agree to the changes.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}